import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const LoaderWrapper = props => {
  let { visible, width = 50, height = 50 } = props;

  return (
    visible && (
      <div style={loaderContainerStyle}>
        <Loader visible={visible} type="ThreeDots" color="#fd397a" width={width} height={height} />
      </div>
    )
  );
};

Loader.propTypes = {
  visible: PropTypes.bool.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

// Style
const loaderContainerStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255,255, 255, 0.8)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: '1000',
};

export default LoaderWrapper;
